// extracted by mini-css-extract-plugin
export default {"center-vertically":"_center-vertically_I7uARB","menu":"_menu_cDCp2x","hidden":"_hidden_6PFOdp"};